import React from 'react';
import { useTranslation } from 'react-i18next';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import data from "../preloaded/colapse_monthly.json"

// Format the month to display only the year and month (e.g., "2022-07")
const formatMonth = (month) => {
  return month.slice(0, 7);
};

// Format the tooltip values in USD
const formatUSD = (value) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(value);
};

const MonthlyFinancialChart = () => {
  const { t } = useTranslation();
  return (
    <div className="p-6 bg-white shadow-lg rounded-lg w-full mx-auto">

      <h2 className="text-xl font-bold text-gray-800 mb-4 text-center">{t('colapse_title')}</h2>
      <p>{t('colapse_info')}</p>
      <br />
      <p>{t('sobrante_def')}</p>
      <p>{t('acumulado_def')}</p>

      <div className="w-full h-[500px] flex justify-center items-center p-4">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={data}
            margin={{ top: 20, right: 30, left: 70, bottom: 15 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="month"
              tickFormatter={formatMonth} // Format the x-axis labels
              interval={0} // Show all labels
              angle={-45} // Rotate labels for better readability
              textAnchor="end"
            />
            <YAxis
              tickFormatter={(value) => formatUSD(value)} // Format the y-axis labels
            />
            <Tooltip
              formatter={(value) => formatUSD(value)} // Format tooltip values
            />
            <Legend
              wrapperStyle={{ paddingTop: '30px' }} // Add padding to the legend
            />
            <Line
              type="monotone"
              dataKey="income"
              stroke="#1D4ED8"
              strokeWidth={2}
              name={t('income')}
            />
            <Line
              type="monotone"
              dataKey="withdrawn"
              stroke="#FF0000"
              strokeWidth={2}
              name={t('withdrawning')}
            />
            <Line
              type="monotone"
              dataKey="sobrante"
              stroke="#000000"
              strokeWidth={2}
              name={t('sobrante')}
            />
            <Line
              type="monotone"
              dataKey="acumulado"
              stroke="#339966"
              strokeWidth={2}
              name={t('acumulado')}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default MonthlyFinancialChart;